const img = {
  i1: require("@/assets/media/3.png"),
  i2: require("@/assets/media/4.png"),
  i3: require("@/assets/media/4.png"),
  i4: require("@/assets/media/6.png"),
  i5: require("@/assets/media/Image2.png"),
  i6: require("@/assets/media/home.png"),
  i7: require("@/assets/media/8.png"),
  i8: require("@/assets/media/9.png"),
  i9: require("@/assets/media/3.png"),
  i10: require("@/assets/media/4.png"),
};

const defaultAgent = {
  name: "أحمد الخالدي",
  role: "مستشار عقاري أول",
  phone: "+965 9999 1234",
  email: "ahmed@kuwait-realestate.kw",
  image: require("@/assets/media/person1.svg"),
};

export const properties = [
  {
    id: 1,
    ref: "KR-2026-001",
    title: "فيلا فاخرة في السالمية",
    location: "السالمية، الكويت",
    areaSlug: "salmiya",
    price: 450000,
    type: "sale",
    category: "villa",
    beds: 5,
    baths: 4,
    area: 420,
    status: "available",
    image: img.i1,
    images: [img.i1, img.i2, img.i3],
    description:
      "فيلا واسعة بتصميم عصري، حديقة خاصة، وموقف سيارات لثلاث مركبات. قريبة من الشاطئ والمدارس الدولية.",
    longDescription:
      "فيلا استثنائية في قلب السالمية تجمع بين الفخامة والموقع الاستراتيجي. تشمل 5 غرف نوم رئيسية، صالة مزدوجة الارتفاع، مطبخ مجهز بالكامل، غرفة خادمة، وحديقة 200م². تبريد مركزي، عزل حراري، ونظام أمن ذكي.",
    amenities: [
      "مسبح",
      "حديقة",
      "موقف 3 سيارات",
      "تكييف مركزي",
      "غرفة خادمة",
      "نظام أمن",
    ],
    features: {
      yearBuilt: 2022,
      parking: 3,
      furnished: false,
      floors: 2,
      facing: "شمال شرقي",
    },
    agent: defaultAgent,
    listedAt: "2026-03-01",
  },
  {
    id: 2,
    ref: "KR-2026-002",
    title: "شقة مطلة على البحر",
    location: "السالمية، الكويت",
    areaSlug: "salmiya",
    price: 1200,
    type: "rent",
    category: "apartment",
    beds: 3,
    baths: 2,
    area: 180,
    status: "available",
    image: img.i2,
    images: [img.i2, img.i1, img.i4],
    description:
      "شقة مفروشة بالكامل بإطلالة بانورامية على الخليج. تشمل مواقف سيارات وصالة رياضية.",
    longDescription:
      "شقة فاخرة في برج سكني راقٍ بالدور الـ15. إطلالة 180° على الخليج العربي. مجهزة بالكامل بأثاث أوروبي. تشمل عضوية صالة رياضية وحمام سباحة في المبنى.",
    amenities: [
      "مفروش",
      "إطلالة بحر",
      "صالة رياضية",
      "حمام سباحة",
      "موقف",
      "أمن 24/7",
    ],
    features: {
      yearBuilt: 2020,
      parking: 2,
      furnished: true,
      floors: 1,
      facing: "شرقي",
    },
    agent: { ...defaultAgent, name: "نورة الصباح" },
    listedAt: "2026-03-10",
  },
  {
    id: 3,
    ref: "KR-2026-003",
    title: "دوبlex في حولي",
    location: "حولي، الكويت",
    areaSlug: "hawally",
    price: 320000,
    type: "sale",
    category: "duplex",
    beds: 4,
    baths: 3,
    area: 310,
    status: "available",
    image: img.i3,
    images: [img.i3, img.i5, img.i6],
    description:
      "دوبlex حديث في موقع هادئ، قريب من المراكز التجارية والمستشفيات.",
    longDescription:
      "دوبlex بمساحتين — الطابق الأرضي: صالة واسعة ومطبخ مفتوح. الطابق العلوي: 4 غرف نوم و3 حمامات. على مسافة قريبة من أڤنيو مول ومستشفى الرشيد.",
    amenities: ["تكييف مركزي", "موقف 2", "شرفة", "مطبخ مجهز", "تخزين"],
    features: {
      yearBuilt: 2019,
      parking: 2,
      furnished: false,
      floors: 2,
      facing: "غربي",
    },
    agent: defaultAgent,
    listedAt: "2026-02-20",
  },
  {
    id: 4,
    ref: "KR-2026-004",
    title: "شقة استوديو للإيجار",
    location: "الجابرية، الكويت",
    areaSlug: "hawally",
    price: 450,
    type: "rent",
    category: "apartment",
    beds: 1,
    baths: 1,
    area: 65,
    status: "available",
    image: img.i4,
    images: [img.i4, img.i3],
    description: "استوديو مثالي للعزاب، مجهز بالكامل وقريب من المترو.",
    longDescription:
      "استوديو حديث في مجمع سكني جديد. مطبخ صغير مجهز، إنترنت، تنظيف أسبوعي. مناسب للموظفين الشباب.",
    amenities: ["مفروش", "WiFi", "تنظيف", "أمن", "مصعد"],
    features: {
      yearBuilt: 2023,
      parking: 1,
      furnished: true,
      floors: 1,
      facing: "جنوبي",
    },
    agent: { ...defaultAgent, name: "سارة المطيري" },
    listedAt: "2026-03-12",
  },
  {
    id: 5,
    ref: "KR-2026-005",
    title: "فيلا عائلية في الأحمدي",
    location: "الأحمدي، الكويت",
    areaSlug: "ahmadi",
    price: 380000,
    type: "sale",
    category: "villa",
    beds: 6,
    baths: 5,
    area: 500,
    status: "pending",
    image: img.i5,
    images: [img.i5, img.i1, img.i8],
    description:
      "فيلا فسيحة مع مسبح خاص وحديقة كبيرة. مناسبة للعائلات الكبيرة.",
    longDescription:
      "فيلا فاخرة للعائلات الكبيرة — 6 غرف نوم بحمامات خاصة، مجلس رجال ونساء منفصلين، مسبح 8×4م، منطقة شواء، ومرآب لـ4 سيارات. في مجمع مغلق.",
    amenities: ["مسبح", "حديقة", "شواء", "مجلس", "موقف 4", "مجمع مغلق"],
    features: {
      yearBuilt: 2021,
      parking: 4,
      furnished: false,
      floors: 2,
      facing: "شمالي",
    },
    agent: defaultAgent,
    listedAt: "2026-01-15",
  },
  {
    id: 6,
    ref: "KR-2026-006",
    title: "مكتب تجاري",
    location: "الشرق، الكويت",
    areaSlug: "sharq",
    price: 2500,
    type: "rent",
    category: "commercial",
    beds: 0,
    baths: 2,
    area: 200,
    status: "available",
    image: img.i6,
    images: [img.i6, img.i7],
    description:
      "مكتب في برج تجاري مرموق، إطلالة على أفق المدينة، مواقف متعددة.",
    longDescription:
      "مكتب من الدرجة A في برج تجاري مرموق — مساحة مفتوحة قابلة للتقسيم، غرفتا اجتماعات، استقبال، و4 مواقف. إنترنت فايبر جاهز.",
    amenities: ["إطلالة مدينة", "موقف 4", "مصعد VIP", "استقبال", "تكييف"],
    features: {
      yearBuilt: 2018,
      parking: 4,
      furnished: false,
      floors: 1,
      facing: "شرقي",
    },
    agent: { ...defaultAgent, name: "فهد العتيبي" },
    listedAt: "2026-03-05",
  },
  {
    id: 7,
    ref: "KR-2026-007",
    title: "شقة 3 غرف في الفروانية",
    location: "الفروانية، الكويت",
    areaSlug: "farwaniya",
    price: 950,
    type: "rent",
    category: "apartment",
    beds: 3,
    baths: 2,
    area: 150,
    status: "available",
    image: img.i7,
    images: [img.i7, img.i4, img.i3],
    description: "شقة نظيفة في مجمع سكني هادئ مع أمن 24 ساعة.",
    longDescription:
      "شقة عائلية في غرب أبو فتيرة — 3 غرف، 2 حمام، صالة وغرفة طعام، بلكونة. ملعب أطفال في المجمع.",
    amenities: ["أمن 24/7", "ملعب أطفال", "موقف", "بلكونة", "تكييف سبليت"],
    features: {
      yearBuilt: 2017,
      parking: 1,
      furnished: false,
      floors: 1,
      facing: "غربي",
    },
    agent: defaultAgent,
    listedAt: "2026-02-28",
  },
  {
    id: 8,
    ref: "KR-2026-008",
    title: "أرض سكنية في مبارك الكبير",
    location: "مبارك الكبير، الكويت",
    areaSlug: "mubarak-al-kabeer",
    price: 180000,
    type: "sale",
    category: "land",
    beds: 0,
    baths: 0,
    area: 600,
    status: "available",
    image: img.i8,
    images: [img.i8, img.i9],
    description: "أرض سكنية في موقع مميز، جاهزة للبناء، جميع الخدمات متوفرة.",
    longDescription:
      "أرض 600م² في موقع استراتيجي بتصنيف سكني. جميع الخدمات متصلة. قطعة زاوية، مناسبة لبناء فيلا من طابقين.",
    amenities: ["زاوية", "خدمات متصلة", "سكني", "طريق رئيسي"],
    features: {
      yearBuilt: null,
      parking: 0,
      furnished: false,
      floors: 0,
      facing: "—",
    },
    agent: defaultAgent,
    listedAt: "2026-03-08",
  },
  {
    id: 9,
    ref: "KR-2026-009",
    title: "penthouse فاخر في السالمية",
    location: "السالمية، الكويت",
    areaSlug: "salmiya",
    price: 850000,
    type: "sale",
    category: "apartment",
    beds: 4,
    baths: 4,
    area: 380,
    status: "available",
    image: img.i10,
    images: [img.i10, img.i2, img.i1],
    description: "penthouse فاخر بتراس خاص 80م² وإطلالة بحرية بزوايا 360°.",
    longDescription:
      "قمة الفخامة — طابق كامل مع مصعد خاص، تراس 80م²، جاكوزي، نظام منزل ذكي، و3 مواقف تحت الأرض.",
    amenities: [
      "تراس",
      "جاكوزي",
      "مصعد خاص",
      "منزل ذكي",
      "إطلالة بحر",
      "موقف 3",
    ],
    features: {
      yearBuilt: 2024,
      parking: 3,
      furnished: true,
      floors: 1,
      facing: "كل الاتجاهات",
    },
    agent: { ...defaultAgent, name: "نورة الصباح" },
    listedAt: "2026-03-14",
  },
  {
    id: 10,
    ref: "KR-2026-010",
    title: "فيلا للإيجار في الأحمدي",
    location: "الأحمدي، الكويت",
    areaSlug: "ahmadi",
    price: 2200,
    type: "rent",
    category: "villa",
    beds: 5,
    baths: 4,
    area: 450,
    status: "available",
    image: img.i1,
    images: [img.i1, img.i5],
    description: "فيلا مفروشة للإيجار السنوي في مجمع سكني هادئ.",
    longDescription:
      "فيلا جاهزة للسكن — 5 غرف نوم، غرفة خادمة، حديقة، ومرآب لسيارتين. يشمل الوصول لمسبح وصالة رياضية في المجمع.",
    amenities: [
      "مفروش",
      "مجمع سكني",
      "مسبح مشترك",
      "صالة رياضية",
      "حديقة",
      "غرفة خادمة",
    ],
    features: {
      yearBuilt: 2020,
      parking: 2,
      furnished: true,
      floors: 2,
      facing: "جنوب شرقي",
    },
    agent: defaultAgent,
    listedAt: "2026-03-11",
  },
];

export function formatPrice(price, type) {
  const formatted = new Intl.NumberFormat("ar-KW", {
    style: "currency",
    currency: "KWD",
    maximumFractionDigits: 0,
  }).format(price);
  return type === "rent" ? `${formatted} / شهر` : formatted;
}

export function getPropertyById(id) {
  return properties.find((p) => p.id === Number(id));
}

export function getSimilarProperties(property, limit = 3) {
  return properties
    .filter(
      (p) =>
        p.id !== property.id &&
        (p.areaSlug === property.areaSlug || p.category === property.category)
    )
    .slice(0, limit);
}

export function getPropertiesByArea(slug) {
  return properties.filter((p) => p.areaSlug === slug);
}

export const categoryLabels = {
  villa: "فيلا",
  apartment: "شقة",
  duplex: "دوبlex",
  commercial: "تجاري",
  land: "أرض",
};

export const amenityIcons = {
  مسبح: "pool",
  حديقة: "garden",
  مفروش: "furnished",
  "إطلالة بحر": "sea",
  "تكييف مركزي": "ac",
  "أمن 24/7": "security",
  موقف: "parking",
};
